import useU2000AxiosNonAuthenticated from '../../axios/U2000UseAxiosNonAuthenticated';

const LOGIN_METHOD_URL = 'U2001/loginMethod';

export type U2000LoginMethod = 'PASSWORD' | 'SSO_GOOGLE';

export type U2000LoginMethodResult = {
  method: U2000LoginMethod;
  authorizeUrl?: string;
};

type LoginMethodFn = (username: string) => Promise<U2000LoginMethodResult>;

/** BL-0520 — détection méthode de connexion (mot de passe vs Google SSO). */
const useU2000LoginMethod = (): LoginMethodFn => {
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doLoginMethod: LoginMethodFn = async (username) => {
    const response = await u2000AxiosNonAuthenticated.post(
      LOGIN_METHOD_URL,
      JSON.stringify({ username }),
    );
    return response.data as U2000LoginMethodResult;
  };

  return doLoginMethod;
};

export default useU2000LoginMethod;
